import { Action } from '@ngrx/store';
import { EvaluationInterface } from 'app/assessment/evaluation/models';
import { ReviewInterface } from 'app/assessment/models/review.model';
import { RecommendationInterface } from 'app/recommendation/models';
import { TaskInterface } from 'app/task/models';

import { EvaluationActionType } from './evaluation-action-type.enum';

// evaluations
export class UpdateEvaluation implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateEvaluation;

  constructor(public readonly payload: EvaluationInterface) { }
}

export class UpdateEvaluationCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateEvaluationCompleted;

  constructor(public readonly payload: EvaluationInterface) { }
}

export class UpdateEvaluationFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateEvaluationFailed;

  constructor(public readonly payload: string) { }
}

// current evaluation
export class UpdateCurrentEvaluation implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateCurrentEvaluation;

  constructor(public readonly payload: EvaluationInterface) { }
}

export class UpdateCurrentEvaluationCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateCurrentEvaluationCompleted;

  constructor(public readonly payload: EvaluationInterface) { }
}

export class UpdateCurrentEvaluationFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateCurrentEvaluationFailed;

  constructor(public readonly payload: string) { }
}

// current evaluation subject's id
export class UpdateCurrentEvaluationRelatedTaskCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateCurrentEvaluationRelatedTaskCompleted;

  constructor(public readonly payload: TaskInterface) { }
}

// add review comments
export class AddNewReviewComment implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.AddNewReviewComment;

  constructor(public readonly payload: {text: string, userId: number, evalId: number}) { }
}

export class AddNewReviewCommentCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.AddNewReviewCommentCompleted;

  constructor(public readonly payload: ReviewInterface) { }
}

export class UpdateEquipmentRecommendationsFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateEquipmentRecommendationsFailed;

  constructor(public readonly payload: string) { }
}

export class AddEvaluationRecommendations implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.AddEvaluationRecommendations;

  constructor(public readonly payload: { evaluation: EvaluationInterface, recommendation: RecommendationInterface}) { }
}

export class AddEvaluationRecommendationsCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.AddEvaluationRecommendationsCompleted;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class AddEvaluationRecommendationsFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.AddEvaluationRecommendationsFailed;

  constructor(public readonly payload: string) { }
}

export class UpdateEvaluationRecommendations implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateEvaluationRecommendations;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class UpdateEvaluationRecommendationsAll implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateEvaluationRecommendations;

  constructor(public readonly payload: RecommendationInterface[]) { }
}

export class UpdateEvaluationRecommendationsCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateEvaluationRecommendationsCompleted;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class UpdateEvaluationRecommendationsFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateEvaluationRecommendationsFailed;

  constructor(public readonly payload: string) { }
}

export class RemoveEvaluationRecommendations implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.RemoveEvaluationRecommendations;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class RemoveEvaluationRecommendationsCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.RemoveEvaluationRecommendationsCompleted;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class AddNewReviewCommentFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.AddNewReviewCommentFailed;

  constructor(public readonly payload: string) { }
}

// update review comments
export class UpdateReviewComment implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateReviewComment;

  constructor(public readonly payload: {review: ReviewInterface, userId: number, evalId: number}) { }
}

export class UpdateReviewCommentCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateReviewCommentCompleted;

  constructor(public readonly payload: ReviewInterface) { }
}

export class UpdateReviewCommentFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.UpdateReviewCommentFailed;

  constructor(public readonly payload: string) { }
}

// delete review comments
export class DeleteReviewComment implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.DeleteReviewComment;

  constructor(public readonly payload: {review: ReviewInterface, userId: number, evalId: number}) { }
}

export class DeleteReviewCommentCompleted implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.DeleteReviewCommentCompleted;

  constructor(public readonly payload: ReviewInterface) { }
}

export class DeleteReviewCommentFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.DeleteReviewCommentFailed;

  constructor(public readonly payload: EvaluationInterface) { }
}

export class RemoveRecommendationsFailed implements Action {
  public readonly type: EvaluationActionType = EvaluationActionType.RemoveRecommendationsFailed;

  constructor(public readonly payload: string) { }
}
